export enum StorageKeys {
	LOGGED_ORG = 'logged_org',
	LOGGED_USER = 'registered_user',
	ACCESS_TOKEN = 'access_token',
	REFRESH_TOKEN = 'refresh_token',
	USER_LANGUAGE = 'user_language',

	FONT_SIZE = 'fontSize',
	TABLES_COLUMNS = 'tables_columns',
	THEME_COLOR = 'theme_color',
	TAB_HASH = 'tab_hash',
	OPEN_TABS = 'open_tabs',
}
